import Constant from "./Constant";

class AddressManager {
    serverAddressArr = []               // 线路地址

    constructor() {
        this.serverAddressArr = Constant.ServerAddresses.slice();
        !cc.sys.localStorage.getItem("ServerAddress") && cc.sys.localStorage.setItem("ServerAddress", this.serverAddressArr[0])
    }

    // 设置服务器域名
    setServerDomain(domain: string) {
        if (this.serverAddressArr.indexOf(domain) !== -1) {
            cc.sys.localStorage.setItem("ServerAddress", domain);
        } else {
            cc.sys.localStorage.setItem("ServerAddress", "");
        }
    }

    //刷新本地服务器列表 并设置新域名 优先续用上次配置
    flushServerList(list) {
        this.serverAddressArr = list;
        let formalDomain = cc.sys.localStorage.getItem("ServerAddress") || ""
        if (this.serverAddressArr.indexOf(formalDomain) === -1) {
            let yxdStr = "://127.0.0.1:";
            if (formalDomain.search(yxdStr) !== -1) {
                let lastAddr = this.serverAddressArr.slice(-1)[0];
                if (lastAddr.search(yxdStr) !== -1) {
                    this.setServerDomain(lastAddr)
                    return;
                }
            }
            this.setServerDomain(this.serverAddressArr[0])
        }
    }

    // 获取服务器域名
    getServerDomain() {
        return cc.sys.localStorage.getItem("ServerAddress");
    }

    //获取服务器地址，唯一接口
    getServerAdress() {
        return this.getServerDomain() + "/imsbase";
    }

    //获取活动地址唯一接口
    getActivityAddress() {
        return this.getServerDomain() + "/imsact";
    }

    //设置阿里地址
    setAliAddress(address: string) {
        if (this.serverAddressArr.indexOf(address) === -1) {
            this.serverAddressArr.unshift(address);
            this.setServerDomain(address);
        }
    }
}

export default new AddressManager()